import getDayViewStore from '../store/store';
import { resetDayViewStore } from '../actions/publicActions';
import { mutator } from 'satcheljs';

/**
 * Mutator to reset the day view store.
 */
const resetDayViewStoreMutator = mutator(resetDayViewStore, () => {
    const { dayViewInDayItemsMap, dayViewAllDayItemsMap } = getDayViewStore();
    dayViewInDayItemsMap.clear();
    dayViewAllDayItemsMap.clear();
});

export default resetDayViewStoreMutator;
